import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import RedemptionHeader from './RedemptionHeader';
import RedemptionForm from './RedemptionForm';
import FrequentlyAskedQuestions from '../GiftFlow/Landing/FrequentlyAskedQuestions';
import { container } from './styles/styles.module.scss';

const RedemptionPage = ({ context }) => (
  <IntlProvider locale="en">
    <div className={container}>
      <RedemptionHeader />
      <RedemptionForm currencyCode={context.currencyCode} couponCode={context.couponCode} />
      <FrequentlyAskedQuestions />
    </div>
  </IntlProvider>
);

export default RedemptionPage;

RedemptionPage.propTypes = {
  context: PropTypes.shape({
    couponCode: PropTypes.string,
    currencyCode: PropTypes.string
  })
};

RedemptionPage.defaultProps = {
  context: PropTypes.shape({
    couponCode: null,
    currencyCode: null
  })
};
